<template>
  <Screen>
    <AppBar title="Reviews" :showBackButton="false">
      <inertia-link
        :href="$route('admin.reviews.create')"
        class="btn btn-sm btn-primary"
      >
        <i class="fa fa-plus"></i>
        <span class="d-none d-app-inline">Add new</span>
      </inertia-link>
    </AppBar>
    <Breadcrumbs title="Reviews" />
    <div class="card">
      <div class="card-body">
        <SearchBar
          @onSubmit="searchSubmit"
          @onClear="searchCleared"
          v-model="searchInput"
        />
        <template v-if="data.data.length > 0">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Ratings</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Updated</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in data.data" :key="item.id">
                  <td>
                    {{ i + 1 }}
                  </td>
                  <td>
                    <img
                      v-lazy="
                        item.image
                          ? item.image_url
                          : `https://ui-avatars.com/api/?background=random&size=400&name${item.name}`
                      "
                      class="img-rounded-sm"
                    />
                  </td>
                  <th>{{ item.name }}</th>
                  <td>{{ item.rating }}</td>
                  <th>
                    <StatusSwitch
                      :dataid="item.id"
                      :status="item.is_active"
                      action="reviewsStatus"
                    />
                  </th>
                  <td>{{ item.created_at_human }}</td>
                  <td>{{ item.updated_at_human }}</td>
                  <td>
                    <inertia-link
                      class="btn btn-sm btn-light"
                      :href="
                        $route('admin.reviews.edit', {
                          id: item.id,
                        })
                      "
                      >Edit</inertia-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <NoData title="No reviews added yet" v-else>
          <inertia-link
            :href="$route('admin.reviews.create')"
            class="btn btn-primary"
            ><i class="fa fa-plus"></i> Add new</inertia-link
          >
        </NoData>
      </div>
    </div>
  </Screen>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: [Array, Object],
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(value) {
        this.searchInput = value;
      },
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
  mounted() {},
  methods: {
    searchSubmit(search) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: search,
        })
      );
    },
    searchCleared() {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: "",
        })
      );
    },
  },
  computed: {},
};
</script>
